import type { Event } from '@hedepy/common/schemas/modules/event/event'
import { useRouter } from 'next/router'
import { useState } from 'react'

import useRebookEvent from '@/legacy-src/components/reservation/hooks/useRebookEvent'

import { useTherapistCart } from '@/src/domains/cart/hooks/useTherapistCart'

export const useClientBookingPlannedEvent = (event: Event) => {
  const router = useRouter()
  const { isRebookingInProgress } = useRebookEvent()
  const { selectedSlots } = useTherapistCart()

  const [isPopoverOpen, setPopoverOpen] = useState(false)
  const [isCancelDialogOpen, setCancelDialogOpen] = useState(false)
  const [isChangeDialogOpen, setChangeDialogOpen] = useState(false)

  const handleChangeEvent = () => {
    setPopoverOpen(false)

    if (selectedSlots.length > 0 && !isChangeDialogOpen) {
      setChangeDialogOpen(true)

      return
    }

    setChangeDialogOpen(false)

    router.push({
      pathname: `/client/${event.therapistId}/profile`,
      query: {
        eventId: event.id,
        service: event.serviceId,
      },
    })
  }

  const handleCancelEvent = () => {
    setPopoverOpen(false)
    setCancelDialogOpen(true)
  }

  return {
    isPopoverOpen,
    setPopoverOpen,
    isChangeDialogOpen,
    setChangeDialogOpen,
    isCancelDialogOpen,
    setCancelDialogOpen,
    isChangesDisabled: !!isRebookingInProgress,
    handleChangeEvent,
    handleCancelEvent,
  }
}
